import { render } from "./AdminRejected25Liquidations.vue?vue&type=template&id=23661ba0"
import script from "./AdminRejected25Liquidations.vue?vue&type=script&lang=js"
export * from "./AdminRejected25Liquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__